import React from "react";
import { Form, Checkbox, Input, Row, Col } from "antd";

const Section5 = ({ formValues, setFormValues }) => {
  const ageGroups = [
    "11 and under",
    "12-18",
    "19-24",
    "25-34",
    "35-44",
    "45-54",
    "55-64",
    "65-74",
    "75+",
  ];

  const lifestyles = [
    "Arts & Culture",
    "Business & Economics",
    "Education",
    "Environmentally Conscious",
    "Fashion & Beauty",
    "Family-Oriented Audiences",
    "Foodies / Dining",
    "Health & Wellness",
    "LGBTQ+",
    "Outdoor Enthusiasts",
    "Politics & Advocacy",
    "Social Media Users",
    "Sports & Fitness",
    "Tech & Gaming",
    "Travel & Leisure",
    "Other (please specify)",
  ];

  const culturalGroups = [
    "Black / African American",
    "Hispanic / Latino",
    "Asian",
    "Native American / Alaska Native",
    "Pacific Islander / Hawaiian",
    "White (European descent)",
    "Other (please specify)",
  ];

  const sortAndSplit = (arr) => {
    const sorted = (arr || []).slice().sort((a, b) =>
      String(a).localeCompare(String(b), undefined, { sensitivity: "base" })
    );
    const half = Math.ceil(sorted.length / 2);
    return {
      left: sorted.slice(0, half),
      right: sorted.slice(half),
    };
  };

  const { left: leftAges, right: rightAges } = sortAndSplit(ageGroups);
  const { left: leftLifestyles, right: rightLifestyles } = sortAndSplit(
    lifestyles
  );
  const { left: leftCultural, right: rightCultural } = sortAndSplit(
    culturalGroups
  );

  return (
    <Form layout="vertical">
      {/* Age Groups */}
      <Form.Item label="21. What age groups do you typically help clients reach?">
        <Checkbox.Group
          value={formValues.ageGroups || []}
          onChange={(checked) => setFormValues({ ...formValues, ageGroups: checked })}
          style={{ width: "100%" }}
        >
          <Row gutter={[0, 8]}>
            <Col xs={24} md={12}>
              {leftAges.map((opt) => (
                <div key={opt} style={{ marginBottom: 8 }}>
                  <Checkbox value={opt}>{opt}</Checkbox>
                </div>
              ))}
            </Col>
            <Col xs={24} md={12}>
              {rightAges.map((opt) => (
                <div key={opt} style={{ marginBottom: 8 }}>
                  <Checkbox value={opt}>{opt}</Checkbox>
                </div>
              ))}
            </Col>
          </Row>
        </Checkbox.Group>
      </Form.Item>

      {/* Lifestyles */}
      <Form.Item label="22. What lifestyles, interests, or communities do you have experience marketing to?">
        <Checkbox.Group
          value={formValues.lifestyles || []}
          onChange={(checked) => setFormValues({ ...formValues, lifestyles: checked })}
          style={{ width: "100%" }}
        >
          <Row gutter={[0, 8]}>
            <Col xs={24} md={12}>
              {leftLifestyles.map((opt) => (
                <div key={opt} style={{ marginBottom: 8 }}>
                  <Checkbox value={opt}>{opt}</Checkbox>
                </div>
              ))}
            </Col>
            <Col xs={24} md={12}>
              {rightLifestyles.map((opt) => (
                <div key={opt} style={{ marginBottom: 8 }}>
                  <Checkbox value={opt}>{opt}</Checkbox>
                </div>
              ))}
            </Col>
          </Row>
        </Checkbox.Group>
      </Form.Item>

      {/* If “Other” is selected for lifestyles */}
      {formValues.lifestyles?.includes("Other (please specify)") && (
        <Form.Item label="Please specify other lifestyles, interests, or communities">
          <Input
            placeholder="Type any other audience types you market to"
            value={formValues.otherLifestyles || ""}
            onChange={(e) =>
              setFormValues({ ...formValues, otherLifestyles: e.target.value })
            }
          />
        </Form.Item>
      )}

      {/* Cultural Groups */}
      <Form.Item label="23. Do you specialize in ethnic or cultural marketing?">
        <Checkbox.Group
          value={formValues.culturalGroups || []}
          onChange={(checked) => setFormValues({ ...formValues, culturalGroups: checked })}
          style={{ width: "100%" }}
        >
          <Row gutter={[0, 8]}>
            <Col xs={24} md={12}>
              {leftCultural.map((opt) => (
                <div key={opt} style={{ marginBottom: 8 }}>
                  <Checkbox value={opt}>{opt}</Checkbox>
                </div>
              ))}
            </Col>
            <Col xs={24} md={12}>
              {rightCultural.map((opt) => (
                <div key={opt} style={{ marginBottom: 8 }}>
                  <Checkbox value={opt}>{opt}</Checkbox>
                </div>
              ))}
            </Col>
          </Row>
        </Checkbox.Group>
      </Form.Item>

      {/* If “Other” is selected for cultural groups */}
      {formValues.culturalGroups?.includes("Other (please specify)") && (
        <Form.Item label="Please specify other ethnic or cultural groups">
          <Input
            placeholder="Type any other cultural focus areas"
            value={formValues.otherCulturalGroups || ""}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                otherCulturalGroups: e.target.value,
              })
            }
          />
        </Form.Item>
      )}
    </Form>
  );
};

export default Section5;
